import PropTypes from "prop-types"

export const TOKEN = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  createdAt: PropTypes.string,
})

export const APPLICATION = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  tokens: PropTypes.arrayOf(TOKEN).isRequired,
})

export const TERMS_AND_CONDITIONS = PropTypes.shape({
  id: PropTypes.string.isRequired,
  license: PropTypes.string.isRequired,
  version: PropTypes.number.isRequired,
  value: PropTypes.string.isRequired,
})
